import React from 'react';

const AlarmClock = ({ className, style, ...props }) => (
  <svg
    className={className}
    style={style}
    {...props}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      /* eslint-disable-next-line max-len */
      d="M9 6V9.75H12.75M15.753 4.17825L13.4542 2.25M4.548 2.25L2.25 4.17825M9 15.75C7.4087 15.75 5.88258 15.1179 4.75736 13.9926C3.63214 12.8674 3 11.3413 3 9.75C3 8.1587 3.63214 6.63258 4.75736 5.50736C5.88258 4.38214 7.4087 3.75 9 3.75C10.5913 3.75 12.1174 4.38214 13.2426 5.50736C14.3679 6.63258 15 8.1587 15 9.75C15 11.3413 14.3679 12.8674 13.2426 13.9926C12.1174 15.1179 10.5913 15.75 9 15.75Z"
      stroke="#9c9c9c"
      strokeWidth="1.2"
      strokeLinecap="square"
    />
  </svg>
);

export default AlarmClock;
